import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { chainsApi } from '@/lib/api/client';
import toast from 'react-hot-toast';

export const decisionKeys = {
  all: ['attachment-decisions'] as const,
  list: () => [...decisionKeys.all, 'list'] as const,
};

export function useAttachmentDecisions() {
  return useQuery({
    queryKey: decisionKeys.list(),
    queryFn: () => chainsApi.listAttachmentDecisions(),
    select: (data) => data.decisions,
  });
}

export function useResolveAttachmentDecision() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: { id: string; action: 'merge' | 'keep_separate'; targetChainId?: string }) =>
      chainsApi.resolveAttachmentDecision(args.id, {
        action: args.action,
        targetChainId: args.targetChainId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: decisionKeys.list() });
      queryClient.invalidateQueries({ queryKey: ['chains'] });
      toast.success('Decision resolved');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to resolve decision');
    },
  });
}
